<template>
  <div :class="classNames">
    <span class="dot dot--1" />
    <span class="dot dot--2" />
  </div>
</template>

<script>
export default {
  props: {
    /**
     * Horizontal alignement: `left`, `right`
     */
    align: {
      type: String,
      default: 'center',
    },
    /**
     * Size: `small`, `default`
     */
    size: {
      type: String,
      default: null,
    },
    /**
     * Negative variant
     */
    negative: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    classNames() {
      return [
        'loader',
        `align-${this.align}`,
        { [`loader--${this.size}`]: !!this.size },
        { 'loader--negative': this.negative },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.loader {
  width: 50px;
  height: 1em * $line-height-default; // Make it take exactly one line of text to avoid jumps
  overflow: hidden;

  display: flex;
  align-items: center;
  justify-content: space-between;
}

.loader--small {
  width: 32px;
}

.dot {
  width: 16px;
  height: 16px;

  border-radius: 50%;
  will-change: transform;

  .loader--small & {
    width: 10px;
    height: 10px;
  }
}

.dot--1 {
  animation: dot1 1.5s infinite;
  background-color: $brand-500;

  .loader--small & {
    animation: dot1--small 1.5s infinite;
  }

  .loader--negative & {
    background-color: $alt-100;
  }
}

.dot--2 {
  animation: dot2 1.5s infinite;
  background-color: $brand-700;

  .loader--small & {
    animation: dot2--small 1.5s infinite;
  }

  .loader--negative & {
    background-color: $alt-300;
  }
}

@keyframes dot1 {
  0% {
    z-index: 1;
  }
  50% {
    transform: translateX(34px);
  }
  100% {
    z-index: 0;
  }
}

@keyframes dot2 {
  50% {
    transform: translateX(-34px);
  }
}

@keyframes dot1--small {
  0% {
    z-index: 1;
  }
  50% {
    transform: translateX(22px);
  }
  100% {
    z-index: 0;
  }
}

@keyframes dot2--small {
  50% {
    transform: translateX(-22px);
  }
}
</style>
